var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-title spaceBetween" }, [
    _c(
      "div",
      { staticClass: "spaceLeft" },
      [
        _vm.back
          ? _c("svg-icon", {
              staticClass: "goback",
              attrs: { "icon-class": "tn-goback" },
              on: { click: _vm.goback },
            })
          : _vm._e(),
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }